import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    contractors: [],
    activeContractors: [],
    listView: false,
    sortBy: '',
    filterBy: '',
    loadingContractors: false,
    showInactive: false,
    selectedRecordType: 'Active'
  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('modifyContractor', '')
      context.commit('modifyContractor', '')
      context.commit('modifyVehicle', '')
      context.commit('modifySite', '')
      context.commit('resetTrips')
    }
  },
  getters: {
    getContractors: state => state.contractors
  }
}
